import React, { useState } from 'react';

const ServiceRequest = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    serviceType: '',
    projectDetails: '',
    timeline: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Call the parent component's onSubmit function
      onSubmit(formData);
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        serviceType: '',
        projectDetails: '',
        timeline: ''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="service-request" id="contact">
      <div className="container">
        <h2>Request My Services</h2>
        <div className="underline-small"></div>
        <p className="section-subtitle">Ready to bring your ideas to life? Let's discuss your project!</p>
        
        <form className="request-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Full Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="serviceType">Service Type *</label>
              <select
                id="serviceType"
                name="serviceType"
                value={formData.serviceType}
                onChange={handleInputChange}
                required
              >
                <option value="">Select a service</option>
                <option value="website-design">Website Design</option>
                <option value="seo-listing">SEO and Listing</option>
                <option value="mobile-apps">Mobile Apps</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>
          
          <div className="form-group full-width">
            <label htmlFor="projectDetails">Project Details *</label>
            <textarea
              id="projectDetails"
              name="projectDetails"
              rows="5"
              placeholder="Tell me about your project, goals, timeline, and any specific requirements..."
              value={formData.projectDetails}
              onChange={handleInputChange}
              required
            ></textarea>
          </div>
          

          
          <div className="form-group full-width">
            <label htmlFor="timeline">Timeline</label>
            <select
              id="timeline"
              name="timeline"
              value={formData.timeline}
              onChange={handleInputChange}
            >
              <option value="">Select timeline</option>
              <option value="asap">ASAP</option>
              <option value="1-2-weeks">1-2 weeks</option>
              <option value="1-2-months">1-2 months</option>
              <option value="3-months-plus">3+ months</option>
              <option value="flexible">Flexible</option>
            </select>
          </div>
          
          <button 
            type="submit" 
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Sending...
              </>
            ) : (
              'Submit Request'
            )}
          </button>
        </form>
      </div>
    </section>
  );
};

export default ServiceRequest; 